"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_toastify_1 = require("react-toastify");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const styles_1 = require("../styles");
const Flex_1 = tslib_1.__importDefault(require("./Elements/Flex"));
const styleType = (props) => {
    if (props.primary) {
        return `
      background-color: ${styles_1.Colors.Primary};
      border-color: ${styles_1.Colors.Primary};
      color: ${styles_1.Colors.White};
    `;
    }
    if (props.success) {
        return `
      background-color: ${styles_1.Colors.Success};
      border-color: ${styles_1.Colors.Success};
      color: ${styles_1.Colors.White};
    `;
    }
    if (props.info) {
        return `
      background-color: ${styles_1.Colors.Info};
      border-color: ${styles_1.Colors.Info};
      color: ${styles_1.Colors.White};
    `;
    }
    if (props.warning) {
        return `
      background-color: ${styles_1.Colors.Warning};
      border-color: ${styles_1.Colors.Warning};
      color: ${styles_1.Colors.White};
    `;
    }
    if (props.danger) {
        return `
      background-color: ${styles_1.Colors.Danger};
      border-color: ${styles_1.Colors.Danger};
      color: ${styles_1.Colors.White};
    `;
    }
    return `
      background-color: ${styles_1.Colors.Secondary};
      border-color: rgba(0, 40, 100, 0.12);
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);
      color: ${styles_1.Colors.Primary};
      &:hover {
        background-color: #f6f6f6;
      }
    `;
};
const Container = (0, styled_components_1.default)(Flex_1.default) `
  min-width: 320px;
  padding: 1rem;
  cursor: pointer;
  ${styleType};
`;
const show = (children) => (0, react_toastify_1.toast)(react_1.default.createElement(Container, null, children));
const success = (children) => (0, react_toastify_1.toast)(react_1.default.createElement(Container, { success: true }, children));
const info = (children) => (0, react_toastify_1.toast)(react_1.default.createElement(Container, { info: true }, children));
const warning = (children) => (0, react_toastify_1.toast)(react_1.default.createElement(Container, { warning: true }, children));
const danger = (children) => (0, react_toastify_1.toast)(react_1.default.createElement(Container, { danger: true }, children));
const primary = (children) => (0, react_toastify_1.toast)(react_1.default.createElement(Container, { primary: true }, children));
const Notify = {
    show,
    success,
    info,
    warning,
    danger,
    primary,
};
exports.default = Notify;
